import { render } from "./ship-data.vue?vue&type=template&id=54e17ba0"
import script from "./ship-data.vue?vue&type=script&lang=js"
export * from "./ship-data.vue?vue&type=script&lang=js"
script.render = render

export default script